import axios from 'axios';


const Totalurl = 'https://api.covidindiatracker.com/total.json';

const stateUrl = 'https://api.covid19india.org/v3/data.json';

const stateUrl2 = 'https://api.covid19india.org/v2/state_district_wise.json';


export const fetchIndiaRecords = async () => {
    try {
        const { data } = await axios.get(`${Totalurl}`);
        let sendData = {
            confirmed: data.confirmed,
            deaths: data.deaths,
            recovered: data.recovered
        }
        return sendData;
    } catch (error) {
        return error;
    }
};

export const fetchDistrictData = async () => {
    try {
        const { data } = await axios.get(`${stateUrl}`);
        return data;
    } catch (error) {
        return error;
    }
};

export const districtDataTwo = async () => {
    try {
        const { data } = await axios.get(`${stateUrl2}`);
        return data;
    } catch (error) {
        return error;
    }
}